import React, { useEffect, useState } from 'react';
import { CogIcon } from '@heroicons/react/solid';
import useNotificationSettings from '../../hooks/useNotificationSettings';
import { putSettings } from '../../redux/services/notificationSettings';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/joy';
import AppSettingsAltRoundedIcon from '@mui/icons-material/AppSettingsAltRounded';

export const NotificationSettings = () => {
  const [settings, setSettings] = useState<Object>({});
  const query = useNotificationSettings();
  const { t } = useTranslation();

  useEffect(() => {
    if (!query.isSuccess) return;
    setSettings(query.data);
  }, [query.data]);

  const toggleField = async (setting: string) => {
    const newSettings = {
      ...settings,
      [setting]: !settings[setting as keyof Object],
    };
    await putSettings(newSettings);
    await query.refetch();
  };

  if (!query.isSuccess) return null;

  return (
    <Stack gap={2}>
      <Typography level="h4">Notificatie instellingen</Typography>

      {/* Settings */}
      <Stack gap={1}>
        {Object.keys(settings).map((setting: string) => {
          return (
            <FormControl key={setting}>
              <Stack direction={'row'} justifyContent={'space-between'}>
                <FormLabel>{t(`profile.${setting}`)}</FormLabel>
                <Switch
                  checked={settings[setting as keyof Object] as any}
                  onChange={(e: any) => {
                    toggleField(setting);
                  }}
                />
              </Stack>
            </FormControl>
          );
        })}
      </Stack>
    </Stack>
  );
};
